import {Message} from "./Message";

export class Group {

  static STATUS_OK: number = 0;
  static STATUS_BLOCKED: number = -1;

  public lastMessage: Message = null;
  public unread: number = 0;
  public status: number = Group.STATUS_OK;

  constructor(public id: string,
              public name: string,
              public description: string,
              public creator: string,
              public photo: string = null) {

  }

  static fromAngularFireSnapshot(snapshot: any) : Group {
    return Group._fromSnapshot(snapshot.key, snapshot.payload.val());
  }

  private static _fromSnapshot(key: string, {name, description, lastMessage, photo, creator}) : Group {
    let group = new Group(key, name, description, creator, photo);
    if (lastMessage) {
      group.lastMessage = new Message(null, lastMessage.sender, lastMessage.contentType, lastMessage.content, lastMessage.date);
    }

    return group;
  }

}



// WEBPACK FOOTER //
// ./src/providers/communication/models/Group.ts